module.exports = __webpack_public_path__ + "media/creativeMedia/panel05Landscape-6342961b.png";